import { render, staticRenderFns } from "./Form4ProcessHeader.vue?vue&type=template&id=b57003ce&scoped=true"
import script from "./Form4ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form4ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form4ProcessHeader.vue?vue&type=style&index=0&id=b57003ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57003ce",
  null
  
)

export default component.exports